export default __webpack_public_path__ + "static/media/img-01.70a24068.jpg";